export const Path = {
    root: "/",
    signin: "/signin",
    signup: "/signup",
    signupResult: "/signup/result",
    terms: "/terms",
    passwordResetSendConfirmationCode: "/password/reset/send-confirmation-code",
    passwordResetSendConfirmationCodeCompleted:
        "/password/reset/send-confirmation-code/completed",
    passwordResetNewPassword: "/password/reset/new-password",
    passwordResetNewPasswordCompleted: "/password/reset/new-password/completed",
    answerers: "/answerers",
    profile: "/profile",
    answerer: "/answerer",
    answererDetail: "/answerer/:id",
    answererDetailQmailSendFrequency: "/answerer/:id/qmailsendfrequency",
    receivernickname: "/answerer/receivernickname",
    memorydetail: "/memory/:id",
    favoriteMemories: "/favorite-memories",
    activities: "/activities",
    senderEmailConfirm: "/answerer/senderemail/confirm",
    sendEmailCompleted: "/answerer/sendEmail/completed",
    useStartMailRemind: "/useStartMailRemind",
    emailConfirm: "/email/confirm",
    wellnessChecksAnswerers: "/wellness-checks",
    wellnessChecks: "/wellness-checks/answerer/:answererId",
    wellnessCheckDetail: "/wellness-checks/answerer/:answererId/:id",
    generatedQCandidate: "/generatedQcandidate",
    activityDetail: "/activity",
    activityReplyDetail: "/activity-reply/:id",
    answererRequiredInfo: "/answerer/required-info",
    answererLineLink: "/answerer/line-link",
    addQuestionAnswerers: "/answerer/questions",
    questionList: "/list/questions",
    addQuestion: "/create/question",
    updateQuestion: "/update/question",
    sentQuestionDetail: "/sent-question",
    postStory: "/post/story",
    storyInfo: "/story/info",
    pushTest: "/push-test",
    error: "/error",
    notFound: "/404",
};
